import { Typography } from '@components/style';
import { useRouterService } from '@hooks/common/UseRouterService';
import { useCheckDevice } from '@hooks/UseCheckDevice';
import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { RowDivider } from '../UserProfileStyles';

type RequestMobileAccessProps = {};

const RequestMobileAccess: FC<RequestMobileAccessProps> = (props) => {
  const { isMobileDevice } = useCheckDevice();
  const { goToPwa } = useRouterService();

  const handleRequestClick = () => {
    goToPwa(false);
  };

  return (
    <RowDivider
      borderColor={isMobileDevice ? theme.palette.backgroundGray : theme.palette.lightGreySix}
    >
      <div className='col-sm-12 col-xs-12'>
        <RequestMobileWrapper>
          <a data-testid='request-mobile-access' onClick={handleRequestClick}>
            <Typography
              marginTop={7}
              size={theme.typography.fontSize14}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.deepBlueTwo}
            >
              Request Mobile Access Outside The Dealership
            </Typography>
          </a>
        </RequestMobileWrapper>
      </div>
    </RowDivider>
  );
};

export default RequestMobileAccess;

const RequestMobileWrapper = styled.div`
  display: flex;
  margin-top: 20px;
`;
